export function isCookiePolicyDialogVisibleSelector(state) {
    const {
        trovitData: { areTermsAndConditionsBeingShown = false } = {},
        isCookiePolicyRejected = false,
        legalDocuments: { cookie_policy: cookiePolicy = {} } = {},
    } = state;
    return (
        undefined !== state.legalDocuments &&
        !areTermsAndConditionsBeingShown &&
        !isCookiePolicyRejected &&
        !cookiePolicy?.acceptedAt
    );
}

export function isCookiePolicySubmitting(state) {
    return state?.cookiePolicyDialog?.isDocumentSubmitting ?? false;
}
